module.exports = __webpack_public_path__ + "static/media/feature-slideg4.27518a22.jpg";